import { render } from "./column.vue?vue&type=template&id=34dc26bc&scoped=true"
const script = {}

import "./column.vue?vue&type=style&index=0&id=34dc26bc&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Desktop/ubang-deploy-work/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34dc26bc"]])

export default __exports__